import React from 'react';
import {useSelector} from 'react-redux';
import {Stack} from '@mui/material';

import ResidentsTable from './ResidentsTable';
import Invoice from '../../Profile/Invoice/Invoice';

import {getIsStakeAdmin} from '../../../../app/store/reducers/session';
import {getDashboardAccount} from '../../../../app/store/reducers/dashboard';

const accountsWithAccessToRewards = ['0014S00000D9ddBQAR', '001Pp000009x0qAIAQ', '0014S000004bYPPQA2', '0014S000004aYHhQAM'];

const CrmTab = () => {
    const isStakeAdmin = useSelector(getIsStakeAdmin);
    const dashboardAccount = useSelector(getDashboardAccount);

    return (
        <Stack direction={'column'} rowGap={3} sx={{width: '100%'}}>
            {(isStakeAdmin || accountsWithAccessToRewards.includes(dashboardAccount?.sfid)) && <Invoice />}
            <ResidentsTable />
        </Stack>
    );
};

export default CrmTab;
